/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CommissionRateServiceVo } from './CommissionRateServiceVo';
import {
    CommissionRateServiceVoFromJSON,
    CommissionRateServiceVoFromJSONTyped,
    CommissionRateServiceVoToJSON,
    CommissionRateServiceVoToJSONTyped,
} from './CommissionRateServiceVo';
import type { MemberCodeVo } from './MemberCodeVo';
import {
    MemberCodeVoFromJSON,
    MemberCodeVoFromJSONTyped,
    MemberCodeVoToJSON,
    MemberCodeVoToJSONTyped,
} from './MemberCodeVo';

/**
 * 
 * @export
 * @interface CommissionRateInitRespVo
 */
export interface CommissionRateInitRespVo {
    /**
     * 会员推荐码信息（基于点击时选择的推荐码）
     * @type {Array<MemberCodeVo>}
     * @memberof CommissionRateInitRespVo
     */
    recommendCodes?: Array<MemberCodeVo>;
    /**
     * 可选附加服务项（billType=3账单可选的附加服务，全部仓库并集）
     * @type {Array<CommissionRateServiceVo>}
     * @memberof CommissionRateInitRespVo
     */
    additionalServices?: Array<CommissionRateServiceVo>;
}

/**
 * Check if a given object implements the CommissionRateInitRespVo interface.
 */
export function instanceOfCommissionRateInitRespVo(value: object): value is CommissionRateInitRespVo {
    return true;
}

export function CommissionRateInitRespVoFromJSON(json: any): CommissionRateInitRespVo {
    return CommissionRateInitRespVoFromJSONTyped(json, false);
}

export function CommissionRateInitRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionRateInitRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendCodes': json['recommendCodes'] == null ? undefined : ((json['recommendCodes'] as Array<any>).map(MemberCodeVoFromJSON)),
        'additionalServices': json['additionalServices'] == null ? undefined : ((json['additionalServices'] as Array<any>).map(CommissionRateServiceVoFromJSON)),
    };
}

export function CommissionRateInitRespVoToJSON(json: any): CommissionRateInitRespVo {
    return CommissionRateInitRespVoToJSONTyped(json, false);
}

export function CommissionRateInitRespVoToJSONTyped(value?: CommissionRateInitRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommendCodes': value['recommendCodes'] == null ? undefined : ((value['recommendCodes'] as Array<any>).map(MemberCodeVoToJSON)),
        'additionalServices': value['additionalServices'] == null ? undefined : ((value['additionalServices'] as Array<any>).map(CommissionRateServiceVoToJSON)),
    };
}

